import { NestedRoutes } from "../../../../app/routes.types";
import { NinetyDayCheckIn } from "./ninetyDayCheckIn";
import { AnnualCheckIn } from "./annualCheckIn";
import { CheckInsHome } from "./checkIns";
import { UserPermissions } from "../../../../enums";

export const CheckInRoutes: NestedRoutes = {
  name: "Check-Ins",
  path: "checkIns",
  defaultPath: "",
  component: CheckInsHome,
  permissions: [
    UserPermissions.MemberViewCheckins,
    UserPermissions.MemberManageCheckins,
  ],
  children: [
    {
      name: "90 Day Review",
      path: "ninetyDayCheckIn",
      component: NinetyDayCheckIn,
    },
    {
      name: "90 Day Review",
      path: "ninetyDayCheckIn/:checkInId",
      component: NinetyDayCheckIn,
    },
    {
      name: "Annual Check-in",
      path: "annualCheckIn",
      component: AnnualCheckIn,
    },
    {
      name: "Annual Check-in",
      path: "annualCheckIn/:checkInId",
      component: AnnualCheckIn,
    },
  ],
};
